import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import IconCart from '../IconCart/IconCart';
import NamedLink from '../NamedLink/NamedLink';
import css from './CartLink.module.css';

/**
 * Authenticated cart entry for topbar surfaces.
 *
 * @param {Object} props
 * @returns {JSX.Element}
 */
const CartLink = props => {
  const { className, count = 0, showLabel = true } = props;

  return (
    <NamedLink className={classNames(css.root, className)} name="CartPage">
      <span className={css.iconWrapper}>
        <IconCart />
        {count > 0 ? <span className={css.badge}>{count}</span> : null}
      </span>
      {showLabel ? (
        <span className={css.label}>
          <FormattedMessage id="CartLink.label" />
        </span>
      ) : null}
    </NamedLink>
  );
};

export default CartLink;
